import { getSortedCollection, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useSystemApi } from "../../../../../common/api/orders-api/system/useSystemApi";
import { DataHooksQueryKey } from "../../../../../common/data/data-hooks/DataHooksQueryKey";
import { mapToSystem, System } from "../../../../../common/types/System";

export const useSystems = (): SprintQueryResult<System[]> => {
    const { getSystemsLookup } = useSystemApi();

    return useSprintQuery<System[]>({
        queryKey: [DataHooksQueryKey.Systems],
        queryFn: async (): Promise<System[]> => {
            const response = await getSystemsLookup();
            const mappedItems = response.items.map(mapToSystem);
            return getSortedCollection(mappedItems, "name");
        }
    });
};
